import GetListStatusRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/status/GetListStatusRequest';
import GetListStatusResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/status/GetListStatusResponse';
import {
  UserModel,
  PaginationResponseModel,
  PriorityModel,
  StatusModel,
  SubtaskModel,
  TagModel,
  TypeModel,
  TaskInSearchModel,
  TaskFileModel,
  QueueRelationModel,
  NamespaceRelationModel,
  WeeekTaskModel,
} from '../../../models';
import GetPrioritiesListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/type-priority/GetPrioritiesListRequest';
import TaskPriorityResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/type-priority/TaskPriorityResponse';
import GetListTaskTypeRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task-type/request/GetListTaskTypeRequest';
import GetListTaskTypeResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task-type/response/GetListTaskTypeResponse';
import GetDifficultyListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/response/GetDifficultyListResponse';
import TagSearchResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/tag/response/TagSearchResponse';
import GetUserListAccessQueueTaskRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetUserListAccessQueueTaskRequest';
import GetUserListAccessQueueTaskResponse from '@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetUserListAccessQueueTaskResponse';
import GetTaskByIdRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetTaskByIdRequest';
import GetTaskByIdResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskByIdResponse';
import {
  AttachSubtaskModel,
  BaseProjectResponseModel,
  CreateFileFolderModel,
  CreateTaskModel,
  CreateTimerRecordModel,
  DeleteInvalidFileRequestModel,
  EditTimerRecordModel,
  GetSubtasksModel,
  GetTimerRecordsModel,
  GetUserRoleByTaskIdsItemModel,
  GetUserRoleByTaskIdsRequsetModel,
  GetUserRoleByTaskIdsResponseModel,
  ProjectGetBuIdRequestModel,
  RemoveFileModel,
  SearchTasksModel,
  StartTimerModel,
  StopTimerModel,
  TaskModel,
  TaskParentModel,
  TaskUpdateDateEndModel,
  TaskUpdateDescriptionModel,
  TaskUpdateDifficultyModel,
  TaskUpdateNameModel,
  TaskUpdateObserversModel,
  TaskUpdatePerformersModel,
  TaskUpdatePriorityModel,
  TaskUpdateStatusModel,
  TaskUpdateTagsModel,
  TaskUpdateTypeModel,
  TimerRecordModel,
  TimerUserModel,
} from '../models';
import TaskCreateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/TaskCreateRequest';
import TaskUpdateNameRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdateNameRequest';
import TaskUpdateStatusRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdateStatusRequest';
import TaskUpdatePriorityRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdatePriorityRequest';
import UpdateTaskTypeRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/UpdateTaskTypeRequest';
import UpdateDifficultyRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/UpdateDifficultyRequest';
import PerformersUpdateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/PerformersUpdateRequest';
import ObserverUpdateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/observer/request/ObserverUpdateRequest';
import AddTagsRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/tag/request/AddTagsRequest';
import GetByParentTaskListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetByParentTaskListRequest';
import PageRequest from '@/api/Main/dataSource/api/pagination-helper/lib/PageRequest';
import GetByParentTaskListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetByParentTaskListResponse';
import TaskUpdateDescriptionRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdateDescriptionRequest';
import GetTaskShortListRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetTaskShortListRequest';
import GetTaskShortListResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetTaskShortListResponse';
import AttachSubtaskRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/AttachSubtaskRequest';
import RemoveSubtaskRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/RemoveSubtaskRequest';
import TaskUpdateDateEndRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/edit/TaskUpdateDateEndRequest';
import GetListRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/GetListRequest';
import GetListResponse from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/GetListResponse';
import TimerStartRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/TimerStartRequest';
import TaskTimerCloseTimerRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/TaskTimerCloseTimerRequest';
import TimerCreateRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/TimerCreateRequest';
import CurrnetLastTimerRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/CurrnetLastTimerRequest';
import TaskTimerDeleteRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/TaskTimerDeleteRequest';
import TaskTimerEditRequest from '@/api/Main/dataSource/api/projects/task-timer/i-service/model/TaskTimerEditRequest';

import RemoveFilesTaskRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/file/RemoveFilesTaskRequest';
import GetShortTaskByIdRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/GetShortTaskByIdRequest';
import GetShortTaskByIdResponse from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/GetShortTaskByIdResponse';
import GetTagsByProjectsIdRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/tag/request/GetTagsByProjectsIdRequest';
import GetDifficultyListItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task-difficulty/response/GetDifficultyListItem';
import UserTaskItem from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UserTaskItem';
import StatusFileEnum from '@/api/Main/dataSource/api/pm/files/ws-client/models/enums/StatusFileEnum';
import { FileFolderTypeEnum } from '@/enums';
import FolderPathTypeEnum from '@/api/File/dataSource/api/pm/common/enums/FolderPathTypeEnum';
import CreateFolderWithoutEntityRequest from '@/api/File/dataSource/api/project-manager/files/i-services/models/request/CreateFolderWithoutEntityRequest';
import { ProjectModel } from '@/models';

export const mapGetStatusesRequest = (queueId: string) =>
  new GetListStatusRequest({
    QueueTasksId: Array.isArray(queueId) ? queueId : [queueId],
    OrderByName: undefined,
  });

export const mapGetStatusesResponse = (response: GetListStatusResponse) =>
  response.Items.map(
    (item) =>
      new StatusModel({
        Id: item.Id,
        Name: item.Name,
        Color: item.Color,
        IsDefault: item.IsDefault,
        Description: item.Description,
      }),
  );

export const mapGetPrioritiesRequest = (queueId: string) =>
  new GetPrioritiesListRequest({
    QueueTasksId: Array.isArray(queueId) ? queueId : [queueId],
  });

export const mapGetPrioritiesResponse = (response: Array<TaskPriorityResponse>) =>
  response.map(
    (item) =>
      new PriorityModel({
        Id: item.Id,
        Name: item.Name,
        Color: item.Color,
        IsDefault: item.IsDefault,
      }),
  );

export const mapGetTypesRequest = (namespaceId: string) =>
  new GetListTaskTypeRequest({
    NamespaceId: namespaceId,
  });

export const mapGetProjectRequest = (projectId: number) =>
  new ProjectGetBuIdRequestModel({
    ProjectId: projectId,
  });

export const mapGetProjectResponse = (response: BaseProjectResponseModel) =>
  new ProjectModel({
    Id: response.Id,
    Name: response.Name,
    ImageUrl: response.ImageUrl,
    PreviewColor: response.PreviewColor,
    WeekEnable: response.WeeekEnable,
    Admins: response.Admins.map(
      (x) =>
        new UserModel({
          Id: x.UserId,
          FirstName: x.FirstName,
          MiddleName: x.MiddleName,
          LastName: x.LastName,
          ImageUrl: x.Foto,
          AvatarColor: x.AvatarColor,
        }),
    ),
  });

export const mapGetTypesResponse = (response: GetListTaskTypeResponse) =>
  response.Items.map(
    (item) =>
      new TypeModel({
        Id: item.Id,
        Name: item.Name,
        Color: item.Color,
        IsDefault: item.IsDefault,
        Description: item.Description,
      }),
  );

export const mapGetDifficultyListResponse = (response: GetDifficultyListResponse) =>
  response.Items.map(
    (item) =>
      new GetDifficultyListItem({
        Id: item.Id,
        Name: item.Name,
        Color: item.Color,
        IsDefault: item.IsDefault,
        NamespaceId: item.NamespaceId,
      }),
  );

export const mapGetTagsRequest = (projectId: number) =>
  new GetTagsByProjectsIdRequest({
    ProjectsId: Array.isArray(projectId) ? projectId : [projectId],
  });

export const mapGetTagsResponse = (response: TagSearchResponse) =>
  response.Tags.map(
    (item) =>
      new TagModel({
        Id: item.Id,
        Name: item.TagName,
        Color: item.Color,
        Description: item.Description,
      }),
  );

export const mapGetEmployeesRequest = (queueId: string) =>
  new GetUserListAccessQueueTaskRequest({
    QueueTaskId: queueId,
  });

export const mapGetEmployeesResponse = (response: GetUserListAccessQueueTaskResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Email: item.Email,
        ImageUrl: item.Foto,
        AvatarColor: item.AvatarColor?.trim() ? item.AvatarColor : '#EC2E14',
      }),
  );

export const mapGetTaskDetailRequest = (taskId: number) =>
  new GetTaskByIdRequest({
    TaskId: taskId,
  });

export const mapGetTaskDetailResponse = (response: GetTaskByIdResponse) =>
  new TaskModel({
    Id: response.Id,
    Parent: response.Parent
      ? new TaskParentModel({
          Id: response.Parent.Id,
          ProjectId: response.Parent.ProjectId,
          QueueId: response.Parent.QueueTaskId,
          NamespaceId: response.NamespaceId,
          Name: response.Parent.Name,
        })
      : undefined,
    Name: response.Name,
    ProjectId: response.ProjectId,
    QueueTaskId: response.QueueTaskId,
    FolderId: response.FolderId,
    NamespaceId: response.NamespaceId,
    StatusId: response.Status?.StatusId,
    TypeId: response.Type?.TypeId,
    PriorityId: response.Priority?.PriorityId,
    DifficultyId: response.DifficultyLevel?.DifficultyId,
    Description: response.Description,
    OwnerId: response.Owner.Id,
    Performers: response.Performers?.map((u) => mapUserModel(u)) || [],
    Observers: response.Observers?.map((u) => mapUserModel(u)) || [],
    PerformerIds: response.Performers?.map((performer) => performer.Id),
    ObserverIds: response.Observers?.map((observer) => observer.Id),
    Estimated: response.WorkTime,
    DeadlineDate: response.DateEnd ? new Date(response.DateEnd + 'Z') : undefined,
    DateCreate: response.DateCreate ? new Date(response.DateCreate + 'Z') : undefined,
    DateUpdate: response.DateUpdate ? new Date(response.DateUpdate + 'Z') : undefined,
    Tags: response.Tags.map((tag) => tag.Id),
    SubtaskCount: response.SubtaskCount,
    QueueToTaskRelationList: response.QueueToTaskRelationList.map(
      (q) =>
        new QueueRelationModel({
          Id: q.Id,
          Name: q.Name,
          Namespace: new NamespaceRelationModel({
            Id: q.Namespace?.Id,
            Name: q.Namespace?.Name,
            Color: q.Namespace?.Color,
            Icon: q.Namespace?.IconUrl,
          }),
        }),
    ),
    Owner: new UserModel({
      Id: response.Owner.Id,
      AvatarColor: response.Owner.AvatarColor,
      ImageUrl: response.Owner.Photo,
      FirstName: response.Owner.FirstName,
      LastName: response.Owner.LastName,
      MiddleName: response.Owner.MiddleName,
    }),
    Files: response.Files?.length
      ? response.Files.map(
          (file) =>
            new TaskFileModel({
              Id: file.Id,
              Url: file.Url,
              Name: file.Name,
              Size: file.Size,
              DateUpload: new Date(file.DateCreated),
              VideoPreviewUrl: file.ThumbnailUrl,
              IsProccessing: file.Status === StatusFileEnum.Proccessing,
              UploadProgress:
                file.Status === StatusFileEnum.Proccessing
                  ? 100
                  : file.Status === StatusFileEnum.InProgress
                  ? 50
                  : undefined,
              User: file.Author
                ? new UserModel({
                    Id: file.Author.Id,
                    FirstName: file.Author.FirstName,
                    LastName: file.Author.LastName,
                    MiddleName: file.Author.MiddleName,
                    ImageUrl: file.Author.Photo,
                    AvatarColor: file.Author.AvatarColor,
                  })
                : undefined,
            }),
        )
      : [],
    WeeekTask: response.WeeekTask
      ? new WeeekTaskModel({
          WeeekTaskId: response.WeeekTask.WeeekTaskId,
          WeeekWorkspaceId: response.WeeekTask.WeeekWorkspaceId,
        })
      : undefined,
  });

const mapUserModel = (user: UserTaskItem) =>
  new UserModel({
    Id: user.Id,
    FirstName: user.FirstName,
    LastName: user.LastName,
    MiddleName: user.MiddleName,
    ImageUrl: user.Photo,
    AvatarColor: user.AvatarColor,
  });

export const mapCreateTaskRequest = (request: CreateTaskModel) =>
  new TaskCreateRequest({
    WeeekTaskId: request.WeeekTask?.WeeekTaskId,
    ProjectId: request.ProjectId,
    QueueTaskId: request.QueueId,
    ParentId: request.Parent?.Id,
    FolderId: request.FolderId,
    Name: request.Name,
    Description: request.Description,
    StatusId: request.StatusId,
    TypeId: request.TypeId,
    PriorityId: request.PriorityId,
    DifficultyId: request.DifficultyId,
    PerformerIds: request.PerformerIds,
    ObserverIds: request.ObserverIds,
    Estimated: request.Estimated,
    DateEnd: request.DeadlineDate,
    Tags: request.Tags,
    SubtaskIds: request.SubtaskIds,
  });

export const mapUpdateTaskNameRequest = (request: TaskUpdateNameModel) =>
  new TaskUpdateNameRequest({
    TaskId: request.Id,
    Name: request.Name,
  });

export const mapUpdateTaskStatusRequest = (request: TaskUpdateStatusModel) =>
  new TaskUpdateStatusRequest({
    TaskId: request.Id,
    StatusId: request.StatusId,
  });

export const mapUpdateTaskPriorityRequest = (request: TaskUpdatePriorityModel) =>
  new TaskUpdatePriorityRequest({
    TaskId: request.Id,
    PriorityId: request.PriorityId,
  });

export const mapUpdateTaskTypeRequest = (request: TaskUpdateTypeModel) =>
  new UpdateTaskTypeRequest({
    TaskId: request.Id,
    TaskTypeId: request.TaskTypeId,
  });

export const mapUpdataTaskDifficultyRequest = (request: TaskUpdateDifficultyModel) =>
  new UpdateDifficultyRequest({
    TaskId: request.Id,
    DifficultyId: request.DifficultyId,
  });

export const mapUpdateTaskPerformersRequest = (request: TaskUpdatePerformersModel) =>
  new PerformersUpdateRequest({
    TaskId: request.Id,
    PerformerIds: request.PerformerIds,
  });

export const mapUpdateTaskObserversRequest = (request: TaskUpdateObserversModel) =>
  new ObserverUpdateRequest({
    TaskId: request.Id,
    UsersId: request.ObserversId,
  });

export const mapUpdateTaskTagsRequest = (request: TaskUpdateTagsModel) =>
  new AddTagsRequest({
    Tags: request.Tags,
    TaskId: request.Id,
    ProjectId: request.ProjectId,
  });

export const mapUpdateTaskDescription = (request: TaskUpdateDescriptionModel) =>
  new TaskUpdateDescriptionRequest({
    TaskId: request.Id,
    Description: request.Description,
  });

export const mapUpdateTaskDeadline = (request: TaskUpdateDateEndModel) =>
  new TaskUpdateDateEndRequest({
    TaskId: request.Id,
    DateEnd: request.DateEnd,
  });

export const mapGetSubtasksRequest = (request: GetSubtasksModel) =>
  new GetByParentTaskListRequest({
    ParentId: request.TaskId,
    QueueTaskId: request.QueueTaskId,
    Page: request.Page
      ? new PageRequest({
          Skip: request.Page.Skip,
          Take: request.Page.Take,
        })
      : undefined,
  });

export const mapGetSubtasksResponse = (response: GetByParentTaskListResponse) =>
  new PaginationResponseModel<Array<SubtaskModel>>({
    Items: response.Items.map(
      (item) =>
        new SubtaskModel({
          Id: item.Id,
          Name: item.Name,
          Status: new StatusModel({
            Id: item.Status.StatusId,
            Name: item.Status.StatusName,
            Color: item.Status.StatusColor,
          }),
          Priority: new PriorityModel({
            Id: item.Priority.PriorityId,
            Name: item.Priority.PriorityName,
            Color: item.Priority.PriorityColor,
          }),
          QueueName: item.QueueTask.Name,
          Performers: item.Performers?.length
            ? item.Performers.map(
                (performer) =>
                  new UserModel({
                    Id: performer.Id,
                    FirstName: performer.FirstName,
                    LastName: performer.LastName,
                    MiddleName: performer.MiddleName,
                    ImageUrl: performer.Photo,
                    AvatarColor: performer.AvatarColor,
                  }),
              )
            : [],
          Queues:
            item.QueueTaskList?.map(
              (q) =>
                new QueueRelationModel({
                  Id: q.Id,
                  Name: q.Name,
                  Namespace: new NamespaceRelationModel({
                    Id: q.Namespace?.Id,
                    Name: q.Namespace?.Name,
                    Color: q.Namespace?.Color,
                    Icon: q.Namespace?.IconUrl,
                  }),
                }),
            ) || [],
        }),
    ),
    Current: response.Page.Current,
    Size: response.Page.Size,
    Count: response.Page.Count,
  });

export const mapSearchTasksRequest = (request: SearchTasksModel) =>
  new GetTaskShortListRequest({
    Page: new PageRequest({
      Skip: request.Page?.Skip,
      Take: request.Page?.Take,
    }),
    Search: request.SearchValue,
    NamespaceId: request.NamespaceId,
    QueueTaskId: request.QueueTaskId,
    IgnoreTaskList: request.IgnoreTaskList,
    WithoutChildTask: request.WithoutChildTask,
  });

export const mapSearchTasksResponse = (response: GetTaskShortListResponse) =>
  new PaginationResponseModel<Array<TaskInSearchModel>>({
    Count: response.Page.Count,
    Current: response.Page.Current,
    Size: response.Page.Size,
    Items: response.Items.map(
      (item) =>
        new TaskInSearchModel({
          Id: item.Id,
          Name: item.Name,
          Code: item.Code,
          Status: item.Status
            ? new StatusModel({
                Id: item.Status.StatusId,
                Name: item.Status.StatusName,
                Color: item.Status.StatusColor,
              })
            : undefined,
        }),
    ),
  });

export const mapAttachSubtaskRequest = (request: AttachSubtaskModel) =>
  new AttachSubtaskRequest({
    TaskId: request.TaskId,
    ParentId: request.ParentTaskId,
  });

export const mapRemoveSubtaskRequest = (subtaskId: number) =>
  new RemoveSubtaskRequest({
    SubtaskId: subtaskId,
  });

export const mapGetTimerRecordsRequest = (request: GetTimerRecordsModel) =>
  new GetListRequest({
    PerformerId: request.PerformerId,
    TaskId: request.TaskId,
  });

export const mapGetTimerRecordsResponse = (response: GetListResponse, isOnlyEnded: boolean) => {
  return response.TasksTimers?.reduce((acc, item) => {
    const record = new TimerRecordModel({
      TimerId: item.TimerId,
      DateStart: item.DateStart ? new Date(item.DateStart + 'Z') : undefined,
      DateEnd: item.DateEnd ? new Date(item.DateEnd + 'Z') : undefined,
      TaskId: item.TaskId,
      Performer: item.Performer
        ? new TimerUserModel({
            Id: item.Performer.UserId,
            FirstName: item.Performer.FirstName,
            LastName: item.Performer.LastName,
            MiddleName: item.Performer.MiddleName,
            AvatarColor: item.Performer.AvatarColor,
            Foto: item.Performer.Foto,
            Email: item.Performer.Email,
          })
        : undefined,
    });

    if (isOnlyEnded && !record.DateEnd) return acc;
    return [...acc, record];
  }, new Array<TimerRecordModel>());
};

export const mapStartTimerRequest = (request: StartTimerModel) =>
  new TimerStartRequest({
    TaskId: request.TaskId,
  });

export const mapStopTimerRequest = (request: StopTimerModel) =>
  new TaskTimerCloseTimerRequest({
    TimerId: request.TimerId,
  });

export const mapCreateTimerRecord = (request: CreateTimerRecordModel) =>
  new TimerCreateRequest({
    TaskId: request.TaskId,
    DateEnd: request.DateEnd,
    DateStart: request.DateStart,
  });

export const mapGetCurrentTimerDateStart = (taskId: number) =>
  new CurrnetLastTimerRequest({
    TaskId: taskId,
  });

export const mapDeleteTimerRecordRequest = (timerId: number) =>
  new TaskTimerDeleteRequest({
    Id: timerId,
  });

export const mapEditTimerRecordRequest = (data: EditTimerRecordModel) =>
  new TaskTimerEditRequest({
    Id: data.TimerId,
    DateStart: data.DateStart,
    DateEnd: data.DateEnd,
  });

export const mapRemoveFileRequest = (request: RemoveFileModel) =>
  new RemoveFilesTaskRequest({
    TaskId: request.TaskId,
    FileId: request.FileId,
  });

export const mapDeleteInvalidFileRequestModel = (request: DeleteInvalidFileRequestModel) =>
  new DeleteInvalidFileRequestModel({
    FolderId: request.FolderId,
    FileId: request.FileId,
  });

export const mapGetParentTaskRequest = (parentTaskId: number) =>
  new GetShortTaskByIdRequest({
    TaskId: parentTaskId,
  });
export const mapGetUserRoleByTaskIdsRequsetModel = (req: GetUserRoleByTaskIdsRequsetModel) => {
  return new GetUserRoleByTaskIdsRequsetModel({
    TaskIds: req.TaskIds,
  });
};

export const mapGetUserRoleByTaskIdsItemModel = (resp: GetUserRoleByTaskIdsResponseModel) => {
  return resp.Items.map((item) => new GetUserRoleByTaskIdsItemModel(item));
};
export const mapGetParentTaskResponse = (resp: GetShortTaskByIdResponse) =>
  new TaskParentModel({
    Id: resp.TaskId,
    Name: resp.Name,
    ProjectId: resp.ProjectId,
    QueueId: resp.QueueTaskId,
    NamespaceId: resp.NamespaceId,
  });

const mapFolderType = (folderType: FileFolderTypeEnum): FolderPathTypeEnum => {
  switch (folderType) {
    case FileFolderTypeEnum.Task:
      return FolderPathTypeEnum.Task;
    case FileFolderTypeEnum.Comment:
      return FolderPathTypeEnum.Comment;
    case FileFolderTypeEnum.Profile:
      return FolderPathTypeEnum.Profile;
    case FileFolderTypeEnum.Project:
      return FolderPathTypeEnum.Project;
    case FileFolderTypeEnum.Icon:
      return FolderPathTypeEnum.Icon;
    case FileFolderTypeEnum.Chat:
      return FolderPathTypeEnum.Chat;
    case FileFolderTypeEnum.MessengerTeam:
      return FolderPathTypeEnum.MessengerTeam;
    case FileFolderTypeEnum.MessengerGroup:
      return FolderPathTypeEnum.MessengerGroup;
    case FileFolderTypeEnum.ChatImage:
      return FolderPathTypeEnum.ChatImage;
    case FileFolderTypeEnum.SoundNotification:
      return FolderPathTypeEnum.SoundNotification;
    case FileFolderTypeEnum.WikiPage:
      return FolderPathTypeEnum.WikiPage;
    case FileFolderTypeEnum.WikiFolder:
      return FolderPathTypeEnum.WikiFolder;
    case FileFolderTypeEnum.GlobalStatuses:
      return FolderPathTypeEnum.GlobalStatuses;
  }
};

export const mapCreateFolderWithoutEntityRequest = (request: CreateFileFolderModel) =>
  new CreateFolderWithoutEntityRequest({
    ProjectId: request.ProjectId,
    Type: mapFolderType(request.Type),
  });
